import React, { useState } from 'react';
import {
  LeftOutlined,
  RightOutlined,
  CloseOutlined,
  FullscreenOutlined,
  FullscreenExitOutlined,
} from '@ant-design/icons';
import './EditChangeRequest.less';
import {
  ChangeRequestDirection,
  ChangeRequestSource,
} from '../../../enums/changeRequest';
import { setCREditingDialogExpanded } from '../../../app/Slices/changeRequestEditSlice';
import {
  useAgentSelector,
  useAgentDispatch,
} from '../../../hooks/useAgentStore';

interface HeaderWithNavigationProps {
  title: string;
  onClose: () => void;
  onNavigate: (direction: ChangeRequestDirection) => void;
  itemCount: number;
  expandToFullScreen: (expand: boolean) => void;
}

const HeaderWithNavigation: React.FC<HeaderWithNavigationProps> = ({
  title,
  onClose,
  onNavigate,
  itemCount,
  expandToFullScreen,
}) => {
  const isSingleItem = itemCount <= 1;
  const agentDispatch = useAgentDispatch();
  const [isFullScreen, setIsFullScreen] = useState(false);
  const { loading, isImplementing, source } = useAgentSelector(
    (state) => state.changeRequest
  );

  const _loading =
    (source === ChangeRequestSource.EDIT_ACTIONS_EXECUTION ||
      source === ChangeRequestSource.EDIT_ANALYSIS_CHECKLIST) &&
    loading;

  const toggleFullScreen = (isEntering: boolean) => {
    agentDispatch(setCREditingDialogExpanded(!isEntering));
    setIsFullScreen(isEntering);
    expandToFullScreen(isEntering);
  };

  return (
    <>
      <div className="edit-change-request-header">
        <span className="header-title overflow-ellipsis" title={title}>
          {title}
        </span>
        <div className="header-right">
          {!isFullScreen && (
            <FullscreenOutlined
              className="action-item"
              onClick={() => {
                toggleFullScreen(true);
              }}
              title="Expand to full screen"
            />
          )}
          {isFullScreen && (
            <FullscreenExitOutlined
              className="action-item"
              onClick={() => {
                toggleFullScreen(false);
              }}
              title="Exit full screen"
            />
          )}
          <div>
            <LeftOutlined
              className="navigate-icon action-item compact-first-item"
              onClick={() => onNavigate(ChangeRequestDirection.PREVIOUS)}
              title="Previous row"
              disabled={isSingleItem || isImplementing || _loading}
            />
            <RightOutlined
              className="navigate-icon action-item compact-last-item"
              onClick={() => onNavigate(ChangeRequestDirection.NEXT)}
              title="Next row"
              disabled={isSingleItem || isImplementing || _loading}
            />
          </div>
          <CloseOutlined
            title="Close"
            className="close-icon action-item"
            onClick={onClose}
            disabled={isImplementing || _loading}
          />
        </div>
      </div>
      {_loading || isImplementing ? (
        <div className="linear-loading"></div>
      ) : null}
    </>
  );
};

export default HeaderWithNavigation;
